export const iconFontAwesomeLogisticsBoxesPacking = (
	<i className="fa-solid fa-boxes-packing"></i>
);
